/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncTopicRanges} from '../api'

export const useMutationSyncTopicRanges = createReactQueryMutationHook('syncTopicRanges', syncTopicRanges)
